import Screen from '@screen';
import styled from 'styled-components';

const DetailAccessibilityContainer = styled.div<React.CSSProperties>`
  position: absolute;
  bottom: 0;
  left: ${Screen.widthRatio * 272}px;
  width: ${Screen.widthRatio * 1472}px;
`;

export default DetailAccessibilityContainer;
